import type { RequestInfo } from '@warp-drive/core/types/request';
import { buildBaseURL, type QueryUrlOptions } from '@warp-drive/utilities';
import { SkipCache } from '@warp-drive/core-types/request';

/**
 * tio-data-side TasProgramInstance request builders. Lives here because
 * the model (`addons/tio-data/src/models/tas-program-instance.ts`)
 * calls these directly, and tio-data can't depend on tio-common.
 *
 * The state-transition + actor-bearing builders live in tio-common
 * (where TasActor lives); split is by where the caller lives, not by
 * domain.
 */
const tasProgramInstancesUrl = (path: string) => {
  const opts: QueryUrlOptions = {
    identifier: { type: 'tas-program-instances' },
    op: 'query',
    resourcePath: 'tas-program-instances',
  };
  return `${buildBaseURL(opts)}/${path.replace(/^\/+/, '')}`;
};

/** GET /tas-program-instances/:id/history */
export function getTasProgramInstanceHistoryRequest(id: string): RequestInfo {
  return {
    url: tasProgramInstancesUrl(`${id}/history`),
    method: 'GET',
    cacheOptions: { [SkipCache]: true },
  };
}
